// Interval helpers for along-wall spans. Moved verbatim out of roomTakeOffs.js.

// Sort + merge an interval list into a non-overlapping union.
function unionIntervals(intervals) {
  if (!intervals.length) return [];
  const arr = intervals
    .map(([a, b]) => [Math.min(a, b), Math.max(a, b)])
    .filter(([a, b]) => b > a)
    .sort((p, q) => p[0] - q[0]);
  if (!arr.length) return [];
  const out = [arr[0].slice()];
  for (let i = 1; i < arr.length; i++) {
    const last = out[out.length - 1];
    if (arr[i][0] <= last[1]) last[1] = Math.max(last[1], arr[i][1]);
    else out.push(arr[i].slice());
  }
  return out;
}

// Subtract a list of [a, b] cut intervals from a base [lo, hi] interval.
// Cuts may overlap, extend past the endpoints, or come in any order.
// Returns sorted, non-overlapping segments [[s0, e0], [s1, e1], ...] where
// each segment is the part of [lo, hi] not covered by any cut.
function subtractIntervals(base, cuts) {
  const [lo, hi] = base;
  if (!Array.isArray(cuts) || cuts.length === 0) return [[lo, hi]];
  const clipped = cuts
    .map(([a, b]) => [
      Math.max(lo, Math.min(a, b)),
      Math.min(hi, Math.max(a, b)),
    ])
    .filter(([a, b]) => b > a);
  if (clipped.length === 0) return [[lo, hi]];
  clipped.sort((p, q) => p[0] - q[0]);
  const merged = [clipped[0].slice()];
  for (let i = 1; i < clipped.length; i++) {
    const last = merged[merged.length - 1];
    if (clipped[i][0] <= last[1]) {
      last[1] = Math.max(last[1], clipped[i][1]);
    } else {
      merged.push(clipped[i].slice());
    }
  }
  const out = [];
  let cursor = lo;
  for (const [a, b] of merged) {
    if (a > cursor) out.push([cursor, a]);
    cursor = Math.max(cursor, b);
  }
  if (cursor < hi) out.push([cursor, hi]);
  return out;
}

module.exports = { unionIntervals, subtractIntervals };
